import { icInfo } from '@vivareal/lina-icons'

export default {
  name: 'oz-buying-power-value',
  data () {
    return {
      icInfo,
    }
  },
  props: {
    color: { type: String },
    title: { type: String },
    amount: { type: String },
    showTooltip: { type: Boolean },
  },
}
